<!-- import app-success -->
<app-success
    titleBtn="متابعة" 
    (Submit)="success()"
    *ngIf="alertSuccess"
    msg='عملية التسجيل تمت بنجاح من فضلك اكمل باقي البيانات'
>
</app-success>

<!-- import app-terms-and-conditions -->
<app-terms-and-conditions 
    *ngIf="showTerms" 
    (close)="showTerms = $event"
>
</app-terms-and-conditions>

<!-- start app-sign-up -->
<div class="sign_up def_p bluer_section">
    <div class="custom_container position-relative">
        <div class="wrap_container">
            <!-- import app-tabs -->
            <app-tabs [tabs]="userTypeTabs"></app-tabs>
        </div>
    
        <div class="wrap_navigate">
            <!-- import app-navigation -->
            <app-navigation [navigate]="navigation"></app-navigation>
        </div>
    
        <div class="wrap_container">
            <form [formGroup]="FormSingUpUser" (ngSubmit)="singUpUser()">
                <ng-container *ngFor="let Input of listInput">
                    <!-- import app-label -->
                    <app-label 
                        [for]="Input.name"
                        [title]="Input.title" 
                        [style]="{color: '#fff'}"
                    >
                    </app-label>

                    <!-- import app-input-phone  -->
                    <app-input-phone 
                        *ngIf="Input.name == 'phone'"
                        [type]="Input.type" 
                        [name]="Input.name" 
                        [FormParent]="FormSingUpUser"
                        (formateNumber)="getCode_hasSelected($event)"
                    >
                    </app-input-phone>

                    <!-- import app-input-text  -->
                    <app-input-text 
                        *ngIf="Input.name != 'phone'"
                        [type]="Input.type" 
                        [name]="Input.name"
                        [FormParent]="FormSingUpUser"
                        [placeholder]="Input.placeholder"
                        [validations]="Input.validators || []"
                        [validatorsErrorMsg]="Input?.validatorsErrorMsg || false"
                    >
                    </app-input-text>
                </ng-container>
    
                <div class="wrap_check">
                    <!-- import app-input-check  -->
                    <app-input-check 
                        name="acceptTerms"
                        [FormParent]="FormSingUpUser" 
                    >
                    </app-input-check>
    
                    <!-- import app-label -->
                    <app-label 
                        for="acceptTerms"
                        class="float-start"
                        title="موافق على الشروط" 
                        [style]="{color: '#fff'}"
                    >
                    </app-label>

                    <a 
                        routerLink="./" 
                        (click)="showTerms = true"
                        class="label_lg_normal float-end main_color"
                    >
                        صفحة الشروط
                    </a>
                    
                    <div class="clearfix"></div>

                    <!-- import app-validation-input  -->
                    <app-validation-input 
                        text="يجب الموافقة علي الشروط و الاحكام"
                        *ngIf="getControl('acceptTerms')?.touched && getControl('acceptTerms')?.errors"
                    >
                    </app-validation-input>
                </div>

                <!-- // show if server backend responded by errors -->
                <ng-container *ngIf="isSuccess">
                    <div class="wrap_error_server text-center">
                        <div class="wrap d-inline-block">
                            <ng-container *ngFor="let validator of isSuccess?.errors">
                                <!-- import app-validation-input  -->
                                <app-validation-input 
                                    [text]="validator.msg"
                                    *ngIf="!isSuccess.success"
                                    [style]="{'margin-inline-start': '0px', margin: 0}" 
                                >
                                </app-validation-input>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                
                <div class="wrap_btn text-center">
                    <!-- import app-btn -->
                    <app-btn 
                        title="تسجيل" 
                        [submit]="true"
                        [disabled]="FormSingUpUser.invalid || isLoading" 
                    >
                    </app-btn>
                    <a routerLink="/sign-in-user" class="label_lg_normal d-block">تسجيل دخول</a>
                </div>
            </form>
        </div>
    </div>
</div>
<!-- end app-sign-up -->